export default {
  namespaced: true,
  hanwha_alarm_profile: {
    title: 'Perfil de alarmas Hanwha | Perfiles de alarmas Hanwha',
    name: 'Nombre', description: 'Descripción', enabled: 'Habilitado', rules: 'Reglas', dvrs: 'DVR asignados',
  },
  hanwha_alarm_rule: {
    title: 'Regla de alarma Hanwha | Reglas de alarmas Hanwha',
    type_log: 'Tipo de log', event_type: 'Evento de alarma', recovery_event_type: 'Evento de restablecimiento',
    channel: 'Canal', alarm_type: 'Tipo de alarma', target: 'Destino', alarm_message: 'Mensaje de alarma',
    recovery_message: 'Mensaje de restablecimiento', delay_seconds: 'Retardo (segundos)', priority: 'Prioridad',
    any_channel: 'Cualquier canal', dvr: 'DVR', camera: 'Cámara', enabled: 'Habilitada',
  },
}
